import React, { useState, useEffect } from 'react'
import ModalInc from '../../../../../shared-ui/ModalInc'
import ButtonInc from '../../../../../shared-ui/ButtonInc'
import { TextValidator, SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import MenuItem from '@mui/material/MenuItem';
import Grid from "@material-ui/core/Grid";
import AlertDialog from '../../../../../components/AlertDialog/index.es6';
import { CircularProgress } from '@mui/material';
import { useStyle } from "./Style";
import find from 'lodash/find';
import { ClaimTypeEnum } from '../../../lib/enum';


const AddClaimExpense = (props) => {
  const classes = useStyle();
  console.log("Claim in add expense", props.claim, "and type", props.type);

  const [expenseType, setExpenseType] = useState('')
  const [invoice_amount_in_cents, setInvoiceAmountInCents] = useState('');
  const [numberOfDays, setNumberOfDays] = useState(props.claim.claim_details.additional_details.number_of_days_in_hospital ? props.claim.claim_details.additional_details.number_of_days_in_hospital : '');
  const [amountInCents, setAmountInCents] = useState('');
  const [invoiceNumber, setInvoiceNumber] = useState('')
  const [deathCertificateNumber, setDeathCertificateNumber] = useState('');
  const [actualDistanceTowed, setActualDistanceTowed] = useState('');



  useEffect(() => {
    const medicalCashBenefit = find(props.claim.benefits, { type: "Medical Cash Plan" });
    const benefit = find(props.claim.benefits, { type: expenseType });
    if (
      expenseType === "Medical Cash Plan" &&
      medicalCashBenefit &&
      medicalCashBenefit.max_benefit_amount_in_cents &&
      numberOfDays
    ) {
      setAmountInCents((medicalCashBenefit.max_benefit_amount_in_cents / 100) * Number(numberOfDays));
    } else  if (expenseType === "Roadside Assistance" ) {
      setAmountInCents(0);
    } else {
      if (benefit && benefit.max_benefit_amount_in_cents) {
        setAmountInCents((Number(benefit.max_benefit_amount_in_cents) / 100));
      }
    }


  }, [expenseType, numberOfDays, props.claim.benefits]);


  const handleChange = (event) => {
    const { name, value } = event.target

    if (name === "invoice_amount_in_cents") {
      setInvoiceAmountInCents(value)
    }
    if (name === "amountInCents") {
      setAmountInCents(value)
    }
    if (name === "selectexpensetype") {
      setExpenseType(value)
      console.log("expense type", value)
    }
    if (name === "numberOfDays") {
      setNumberOfDays(value)
    }
    if (name === "invoiceNumber") {
      setInvoiceNumber(value)
    }
    if(name === "deathCertificateNumber"){
      setDeathCertificateNumber(value)
    }
    if(name === "actualDistanceTowed"){
      setActualDistanceTowed(value)
    }

  }
  const reset = () => {
    setInvoiceAmountInCents('');
    setDeathCertificateNumber('')
    setAmountInCents('');
    setNumberOfDays('');
    setExpenseType('');
    setInvoiceNumber('');
    setActualDistanceTowed('');
  }
  const handleClaimExpense = () => {
    const payload = {
      "benefit_type": expenseType,
      "invoice_amount_in_cents": Number(invoice_amount_in_cents) * 100,
      "benefit_amount_in_cents": Number(amountInCents) * 100,
      "benefit_usage_count": expenseType === "Medical Cash Plan" ? Number(numberOfDays) : 0,
      "invoice_number": invoiceNumber,
      "external_unique_identifier":  props.type === ClaimTypeEnum.death ? deathCertificateNumber : null,
      "actual_distance_towed_km": expenseType === "Roadside Assistance" ? Number(actualDistanceTowed) : null,
      "claim_guid": props.claim.guid

    }
   props.handleClaimExpense(payload)
    reset()
  }
  const handleExpenseCreatedSuccessfully = () => {
    props.resetCreateExpenseSuccessAlert();
    props.toggleClaimExpenseDialog();
    window.location.reload();
  }
  const handleExpenseCreateError = () => {
    props.resetCreateExpenseErrorAlert();
  }

  const amountLabel = props.type === ClaimTypeEnum.hospital ? "Amount Payable" : (
    props.type === ClaimTypeEnum.death ? "Benefit Amount Payable" : "Invoice Amount"
  )
  const descriptionLabel = props.type === ClaimTypeEnum.hospital ? "Invoice Amount" : (
    props.type === ClaimTypeEnum.death ? "Death Certificate Number" : "Description (invoice/receipt Amount) "
  )
  return (
    <>
      <AlertDialog
        custom
        show={props.showCreateExpenseProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2> Creating Claim Expense...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showCreateExpenseSuccessAlert}
        size="sm"
        title={'Claim expense created'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleExpenseCreatedSuccessfully() }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={true}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >

      </AlertDialog>

      <AlertDialog
        show={props.showCreateExpenseErrorAlert}
        danger
        title={'Error creating claim expense'}
        onConfirm={() => handleExpenseCreateError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >

        {props.CreateExpenseError ? props.CreateExpenseError.message : ''}
      </AlertDialog>
      <ModalInc
        modalTitle="Input  Details"
        subTitle="Fill the below fields to add details"
        open={props.openClaimExpenseDialog}
        onClose={props.toggleClaimExpenseDialog}
        fullWidth

      >
        <ValidatorForm onSubmit={() => handleClaimExpense()} >
          <Grid container spacing={2} className={classes.editClaimDialog}>
            <Grid item xs={12} sm={12} md={12}>
              <SelectValidator
                labelId="select-expense-type"
                id="select-expense-type"
                value={expenseType}
                name='selectexpensetype'
                type="text"
                label="Select  Type"
                onChange={handleChange}
                variant="outlined"
                validators={['required']}
                errorMessages={['Please select type']}
                style={{ width: "100%" }}
                sx={{
                  fontFamily: "Open Sans",
                  fontStyle: "normal",
                  fontWeight: 300,
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0.005em",
                  color: "#000000",
                }}
              >

                {
                  props.claim.benefits.map((benefit, index) => (
                    <MenuItem
                      key={index}
                      sx={{
                        fontFamily: "Open Sans",
                        fontStyle: "normal",
                        fontWeight: 300,
                        fontSize: "12px",
                        lineHeight: "16px",
                        letterSpacing: "0.005em",
                        color: "#000000",
                      }}
                      value={benefit.type}>{benefit.type}</MenuItem>
                  ))
                }

              </SelectValidator>
            </Grid>

            {
              expenseType === "Medical Cash Plan" ? (<>
                <Grid item xs={12} sm={12} md={12}>
                  <TextValidator
                    name='numberOfDays'
                    id="numberOfDays"
                    label="Number Of Days"
                    type="number"
                    value={numberOfDays}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    validators={['required']}
                    errorMessages={['Please enter number of days']}
                  />
                </Grid>
              </>) : (<>
              </>)
            }
            {
              expenseType === "Roadside Assistance" ? (<>
                <Grid item xs={12} sm={12} md={12}>
                  <TextValidator
                    name='actualDistanceTowed'
                    id="actualDistanceTowed"
                    label="Actual Distance Towed (KMs)"
                    type="number"
                    value={actualDistanceTowed}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                    validators={['required', 'minNumber:0']}
                    errorMessages={['Please enter the actual distance towed in kilometers']}
                  />
                </Grid>
              </>) : (<>
              </>)
            }
            <Grid item xs={12} sm={12} md={12}>
              {
                props.type === ClaimTypeEnum.death ? (<TextValidator
                  name='deathCertificateNumber'
                  id="deathCertificateNumber"
                  label={descriptionLabel}
                  type='number'
                  value={deathCertificateNumber}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please enter death certificate number']}
                />) : (<TextValidator
                  name='invoice_amount_in_cents'
                  id="invoice_amount_in_cents"
                  label={descriptionLabel}
                  type='text'
                  value={invoice_amount_in_cents}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please enter invoice amount']}
                />)
              }

            </Grid>


            <Grid item xs={12} sm={12} md={12}>
              <TextValidator
                name='amountInCents'
                id="amountInCents"
                label={amountLabel}
                type="number"
                value={amountInCents}
                disabled={props.type === "Accidental death and disability cover P 20,000" || props.type === "Accidental death and disability cover P 50,000" || props.type === 'Medical Cash Plan' ? true : false}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                validators={['required']}
                errorMessages={['Please enter Amount']}
              />
            </Grid>
            {
              (props.type === ClaimTypeEnum.hospital ||
                props.type === ClaimTypeEnum.legal ||
                props.type === ClaimTypeEnum.bdfAndPrisons) &&
              <Grid item xs={12} sm={12} md={12}>
                <TextValidator
                  name='invoiceNumber'
                  id="invoiceNumber"
                  label="Invoice Number"
                  type="text"
                  value={invoiceNumber}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  validators={['required']}
                  errorMessages={['Please enter invoice number']}
                />
              </Grid>
            }


          </Grid>
          <Grid container spacing={2} >
            <Grid item xs={12} sm={6} md={6}>

            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={8} md={8}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    type='submit'
                    style={{ marginTop: "20px", float: "right" }}
                  >
                    Save details
                  </ButtonInc>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <ButtonInc
                    variant="contained"
                    color="primary"
                    size="large"
                    style={{ marginTop: "20px" }}
                    onClick={props.toggleClaimExpenseDialog}
                  >
                    Cancel
                  </ButtonInc>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ValidatorForm>
      </ModalInc>

    </>
  )
}

export default AddClaimExpense